import { readDamageControlPhoto } from "@/services/damageControlPhoto";

// Restored damage-control photos are kept separately from FT-186 booking captures.
let restored = null;

export function storeRestoredDamageControl(pending, photo) {
  if (!pending || pending.kind !== "damage_control" || !photo || !(photo.webPath || photo.path)) return null;
  restored = {
    inspectionId: String(pending.inspectionId),
    zoneKey: String(pending.zoneKey),
    series: Number(pending.series),
    attempt: Number(pending.attempt),
    capturedAt: pending.at,
    photo,
  };
  return peekRestoredDamageControl(pending.inspectionId, pending.zoneKey);
}

export function hasRestoredDamageControl(inspectionId, zoneKey) {
  return Boolean(restored && restored.inspectionId === String(inspectionId) && restored.zoneKey === String(zoneKey));
}

export function peekRestoredDamageControl(inspectionId, zoneKey) {
  if (!hasRestoredDamageControl(inspectionId, zoneKey)) return null;
  const { series, attempt, capturedAt } = restored;
  return { series, attempt, capturedAt, sequence: { series, attempt } };
}

export async function takeRestoredDamageControl(inspectionId, zoneKey, deps = {}) {
  if (!hasRestoredDamageControl(inspectionId, zoneKey)) return null;
  const item = restored;
  const blob = await readDamageControlPhoto(item.photo, deps);
  Object.defineProperties(blob, {
    capturedAt: { value: item.capturedAt, enumerable: true },
    sequence: { value: { series: item.series, attempt: item.attempt }, enumerable: true },
  });
  if (restored === item) restored = null;
  return { original: blob, series: item.series, attempt: item.attempt };
}

export function discardRestoredDamageControl(inspectionId, zoneKey) {
  if (!hasRestoredDamageControl(inspectionId, zoneKey)) return false;
  restored = null;
  return true;
}

export function resetRestoredDamageControl() { restored = null; }
